import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../global/Button';
import withModal from '../../global/modal/withModal';

export const SIBLING_DISCOUNT_ALERT_MODAL = 'modal/SIBLING_DISCOUNT_ALERT';

const propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  onAddAnotherCamper: PropTypes.func.isRequired,
};

const SiblingDiscountAlert = ({ onRequestClose, onAddAnotherCamper }) => {
  return (
    <div className="text-center px-3">
      <h2 className="text-extra-bold mb-1">
        Your camp offers a sibling discount!
      </h2>

      <p className="mb-4">
        If you have more than one camper attending this summer, please be sure
        to add them now as discounts only apply when purchased together.
      </p>

      <div className="d-flex flex-column">
        <Button btnBlock btnStyle="primary" onClick={onRequestClose}>
          I only have one camper
        </Button>

        <Button
          btnBlock
          btnStyle="secondary"
          className="mb-1"
          onClick={() => {
            onAddAnotherCamper();
            onRequestClose();
          }}
        >
          Add another camper
        </Button>
      </div>
    </div>
  );
};

SiblingDiscountAlert.propTypes = propTypes;

export default withModal(SiblingDiscountAlert, {
  name: SIBLING_DISCOUNT_ALERT_MODAL,
  size: 'sm',
});
